import * as Core from "@refinedev/core-original";
import React from "react";

export const useResource = (identifier?: string) => {
  const ctx = React.useContext(Core.ResourceContext as any) as any;
  const resources: any[] = (ctx && (ctx as any).resources) || [];
  const resource = identifier
    ? resources.find((r) => r?.identifier === identifier || r?.name === identifier)
    : undefined;
  return { resources, resource } as any;
};

export * from "@refinedev/core-original";

